import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../App';
import { LogInSchoolID } from '../../JS/Common';
import { hasRoleAccess, RoleEnum } from '../../JS/RoleType';
import useConfig from '../../Hooks/useConfig';

export default function LeftMenu({ isWrapperToggled, setIsWrapperToggled, FinalPath }) {
    const { is_enterprise, shop_link, show_shop, show_partnership_reseller, left_menu_white_logo,
        show_part_order_module, dynamic_left_menu_logo_height, left_menu_dcc_text } = useConfig();
    const [activeSubmenuItem, setActiveSubmenuItem] = useState('');
    const { UserData, menuData } = useContext(UserContext);
    const navigate = useNavigate();
    const effectiveRole = UserData.copyrole || UserData.role || null;
    const OnlyVar = hasRoleAccess(effectiveRole, RoleEnum.ONLY_VAR);

    useEffect(() => {
        getFilteredMenu();
    }, [])
    const handleMenuClick = (item, e) => {
        const isCtrlPressed = e.ctrlKey || e.metaKey;
        if (isCtrlPressed) {
            window.open(item.href, '_blank');
        } else {
            navigate(item.href);
        }
    };
    const handleSubmenuClick = (subItem, e) => {
        const isCtrlPressed = e.ctrlKey || e.metaKey;
        if (isCtrlPressed) {
            if (UserData.helpdeskUpdatedFlag != null && subItem?.href == 'ticket-assignments') {
                window.open('/helpdesk-ticket-assignments', '_blank');
            } else {
                window.open(subItem.href, '_blank');
            }
        } else {
            if (UserData.helpdeskUpdatedFlag != null && subItem?.href == 'ticket-assignments') {
                navigate('/helpdesk-ticket-assignments')
            } else {
                navigate(subItem.href);
            }
        }
    };
    function toggleWrapper() {
        if (isWrapperToggled) {
            setIsWrapperToggled(false);
        } else {
            setIsWrapperToggled(true);
        }
    };
    const getFilteredMenu = () => {
        // For K12 tech roles (old 6,17), filter menu based on whether they are
        // running as school-admin (copyrole present) or as K12 tech.
        if (effectiveRole === 'k12_repair_tech' || effectiveRole === 'k12_lead_tech') {
            if (UserData.copyaccesstype) {
                return menuData.filter(item => item.school_admin_flag == 2);
            } else {
                return menuData.filter(item => item.school_admin_flag == 1);
            }
        }

        // All other roles see the full menuData
        return menuData;
    };
    return (
        <aside className="side-menu-scroll-style sidebar-wrapper" data-simplebar="init">
            <div className="simplebar-wrapper m-0">
                <div className="simplebar-height-auto-observer-wrapper">
                    <div className="simplebar-height-auto-observer"></div>
                </div>
                <div className="simplebar-mask">
                    <div className="simplebar-offset" style={{ right: "0px", bottom: "0px" }}>
                        <div className="simplebar-content-wrapper" style={{ height: "100%", overflow: "hidden" }}>
                            <div className="simplebar-content mm-active p-0">
                                <div className="sidebar-header cursor-pointer">
                                    {UserData.schoollogo == null ?
                                        <div className="logo-shimmer" style={{ '--dynamic-height': '35px' }} />
                                        : <img src={UserData.schoollogo || left_menu_white_logo}
                                            className="logo-icon Leftmenulogo"
                                            alt="Logo"
                                            loading="eager"
                                            style={{ '--dynamic-height': dynamic_left_menu_logo_height }}
                                            onClick={toggleWrapper}
                                        />
                                    }
                                    <div className="toggle-icon ms-auto" id="sidebar-toggle" onClick={toggleWrapper}><i className="bi bi-list"></i></div>
                                </div>
                                <ul className="metismenu mm-show">
                                    {getFilteredMenu().filter(item => {
                                        if ((OnlyVar && item.name == left_menu_dcc_text) || (is_enterprise && item.name == left_menu_dcc_text)) {
                                            return false;
                                        }
                                        if (item.name == 'Parts Orders' && !show_part_order_module) {
                                            return false;
                                        }
                                        if (item.name == 'Shop' && !show_shop) {
                                            return false;
                                        }
                                        return true;
                                    }).map((item, i) => {
                                        const isActive = FinalPath ? item.href == FinalPath : i == 0;
                                        return (
                                            <div key={i}>
                                                {item?.submenu?.length == 0 ?
                                                    <li className={isActive ? 'mm-active' : ''} onClick={window.innerWidth <= 767 ? toggleWrapper : null}>
                                                        <a className='d-flex align-items-center' title={item.name}
                                                            onClick={(e) => item.name == "Shop" ? window.open(shop_link, "_blank") : handleMenuClick(item, e)}>
                                                            <FontAwesomeIcon icon={fas[item.image.replace('fa-', '')]} className='parent-icon p-1 smallicon' />
                                                            <div className="menu-title">{item.name}</div>
                                                        </a>
                                                    </li>
                                                    :
                                                    <li>
                                                        <a className='d-flex align-items-center justify-content-between' title={item.name}
                                                            onClick={(e) => setActiveSubmenuItem((prevItem) => prevItem == item.name ? '' : item.name)}>
                                                            <div className="d-flex align-items-center">
                                                                <FontAwesomeIcon icon={fas[item.image.replace('fa-', '')]} className='parent-icon p-1 smallicon' />
                                                                <div className="menu-title">{item.name}</div>
                                                            </div>
                                                            <div className="d-flex align-items-center">
                                                                <div className="menu-title">
                                                                    <FontAwesomeIcon icon={activeSubmenuItem == item.name ? faAngleUp : faAngleDown} className='parent-icon p-1 text-end' style={{ height: "15px", width: "15px" }} />
                                                                </div>
                                                            </div>
                                                        </a>
                                                        {activeSubmenuItem == item.name && (
                                                            <div className='py-1'>
                                                                {item?.submenu?.filter(subItem => {
                                                                    // if (LogInSchoolID == 0 && subItem.name == "Import/Export" && is_enterprise) {
                                                                    //     return false
                                                                    // }
                                                                    if (subItem.name === 'External Entities' && (OnlyVar || !show_partnership_reseller)) {
                                                                        return false;
                                                                    }
                                                                    // Hide reseller users for non-VAR roles
                                                                    if (!OnlyVar && subItem.name == 'Reseller Users') {
                                                                        return false;
                                                                    }
                                                                    if (subItem.name == 'Users Groups') {
                                                                        return false;
                                                                    }
                                                                    return true
                                                                }).map((subItem, j) => {
                                                                    const matchString = UserData.helpdeskUpdatedFlag != null && subItem.href == "ticket-assignments" ? "helpdesk-ticket-assignments" : subItem.href;
                                                                    const isSubActive = matchString == FinalPath;
                                                                    const shouldHide = UserData.helpdeskUpdatedFlag == null && subItem.name == "Other";
                                                                    return (
                                                                        <li
                                                                            key={j}
                                                                            className={`${isSubActive ? 'mm-active' : ''} ${shouldHide ? 'd-none' : ''}`}
                                                                            onClick={window.innerWidth <= 767 ? toggleWrapper : null}
                                                                        >
                                                                            <a className={`d-flex ${!isWrapperToggled ? 'ps-5' : 'ps-4'} align-items-center ps-3`} onClick={(e) => handleSubmenuClick(subItem, e)} title={subItem.name}>
                                                                                <FontAwesomeIcon
                                                                                    icon={fas[subItem.image.replace('fa-', '')]}
                                                                                    className="parent-icon p-1"
                                                                                    style={{ height: "20px", width: "20px" }}
                                                                                />
                                                                                <div className="menu-title ms-1">{subItem.name}</div>
                                                                            </a>
                                                                        </li>

                                                                    )
                                                                })}
                                                            </div>
                                                        )}
                                                    </li >
                                                }
                                            </div>
                                        )
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </aside>
    )
}
